/************************************
MODULE:         Cookie bar
WHAT IT DOES:   contains all cookie bar appearing/disappearing functinoality
*************************************/
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    }
    else if (typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    }
    else { root.returnExports = factory(root.jQuery); }
}(this, function ($) {

    var cookieName = 'allowcookies',
        animationTime = 0.4,
        CookieBar,
        CookieBarCloseBtn,
        OnScrollApp,
        StringUtils,
        isOpened = false,
        $body;

    function initCookie(onScrollApp, stringUtils) {
        require('jquery.cookie');
        var cookie = $.cookie(cookieName);
        $body = $('body');

        OnScrollApp = onScrollApp;
        StringUtils = stringUtils;
        if ((typeof cookie !== 'undefined') ||
            $body.hasClass('cms-bootstrap') ||
            $body.hasClass('DesignMode') ||
            $body.hasClass('EditMode')) {
            return;
        }

        $(window).on('init:allIsReady', assignScrollDetectionOnce);
    }

    function assignScrollDetectionOnce() {
        OnScrollApp.assignFixers($body, showOnceCookieNotificationOnScroll, true);
        $(window).off('init:allIsReady', assignScrollDetectionOnce);
    }

    function showOnceCookieNotificationOnScroll() {
        OnScrollApp.deassignFixers(showOnceCookieNotificationOnScroll);
        openCookie();
    }

    function openCookie() {
        $body.append(StringUtils.hexToStr(window.App.globals.cookieHlobNotification));

        CookieBar = $('.js-cookie-bar');
        if (!CookieBar.length) {
            return;
        }

        CookieBarCloseBtn = $('.js-close-cookie-bar');
        CookieBarCloseBtn.on('click', function (e) {
            e.preventDefault();
            closeCookie();
        });

        isOpened = true;

        var TweenMax = require('tweenmax'),
            tween = new TimelineMax({ onComplete: refresh });

        $(window).trigger('cookie:opened');
        CookieBar.css('top', 'auto');
        tween.fromTo(CookieBar, animationTime, { bottom: -window.App.globals.cookieHeight }, { bottom: 0, ease: "easeOut" });
        tween.fromTo($body, animationTime, { paddingBottom: 0 }, { paddingBottom: window.App.globals.cookieHeight, ease: "easeOut" }, "-=" + animationTime);
        tween.play();
    }

    function closeCookie() {
        isOpened = false;

        CookieBarCloseBtn.off('click');

        $.cookie(cookieName, 'true', { expires: 180, path: '/' });

        var TweenMax = require('tweenmax'),
            tween = new TimelineMax({ onComplete: refresh });

        $(window).trigger('cookie:closed');
        tween.fromTo(CookieBar, animationTime, { bottom: 0 }, { bottom: -window.App.globals.cookieHeight, ease: "easeOut" });
        tween.fromTo($body, animationTime, { paddingBottom: window.App.globals.cookieHeight }, { paddingBottom: 0, ease: "easeOut" }, "-=" + animationTime);
        tween.play();
    }

    function refresh() {
        $(window).trigger('resize');
        if (!isOpened) {
            CookieBar.css({'height': 0, 'display': 'none'});
        }
    }

    return {
        init: initCookie
    }

}));



/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/app.cookie.js
 ** module id = 36
 ** module chunks = 24
 **/